import { Controller } from '@hotwired/stimulus';
import { detectTransition, pendingRecipes } from './mixins/recipe_transition';

export default class extends Controller {
  static targets = [
    'currentInterval',
    'newInterval',
    'currentDiscountAmount',
    'newDiscountAmount',
    'couponSection',
    'transitionSection',
    'defaultHeader',
    'confirmButton',
    'cancelButton',
  ];

  static values = {
    originalSkuId: String,
    couponKind: String,
    originalRecipes: Array,
    transitionMappings: Array,
  };

  static TRANSITION_LABELS = { confirm: 'Save Changes', cancel: 'Discard Changes' };
  static DEFAULT_LABELS = { confirm: 'Confirm', cancel: 'Cancel' };

  connect() {
    this.applyTransitionState(this.detectTransition());
  }

  update() {
    this.applyTransitionState(this.detectTransition());
    // Get recipe names dynamically from the form
    const recipeForm = document.querySelector('#recipe-form');
    let selectors = ['beef', 'chicken', 'turkey'];

    if (recipeForm) {
      const recipesData = recipeForm.dataset.recipes;
      if (recipesData) {
        // Rails dataset attributes are always strings, so parse as JSON
        try {
          selectors = JSON.parse(recipesData);
        } catch {
          // Fallback: try splitting by comma if JSON parsing fails
          selectors = recipesData
            .split(',')
            .map((s) => s.trim().replace(/[[\]"]/g, ''));
        }
      }
    }

    if (this.hasCurrentIntervalTarget && this.hasNewIntervalTarget) {
      const intervalValue = this.currentIntervalTarget.value;
      // Format the interval: convert to weeks if divisible by 7, otherwise show days
      const days = parseInt(intervalValue, 10);
      if (days && days % 7 === 0) {
        const weeks = days / 7;
        this.newIntervalTarget.textContent = `${weeks} ${
          weeks === 1 ? 'week' : 'weeks'
        }`;
      } else {
        this.newIntervalTarget.textContent = `${days} ${
          days === 1 ? 'day' : 'days'
        }`;
      }
    }

    if (
      this.hasNewDiscountAmountTarget &&
      this.hasCurrentDiscountAmountTarget
    ) {
      const skuSelect = document.querySelector('#sku_select');
      const skuChanged =
        skuSelect && skuSelect.value !== this.originalSkuIdValue;
      const isMigrationCoupon = this.couponKindValue === 'pricing_migration';

      if (skuChanged && isMigrationCoupon) {
        if (this.hasCouponSectionTarget) {
          this.couponSectionTarget.style.display = 'none';
        }
        this.newDiscountAmountTarget.textContent = '$0.00';
      } else {
        if (this.hasCouponSectionTarget) {
          this.couponSectionTarget.style.display = '';
        }
        this.newDiscountAmountTarget.textContent =
          this.currentDiscountAmountTarget.textContent;
      }
    }

    selectors.forEach((selector) => {
      const originElement = document.querySelector(
        `.account-recipe-grid.${selector}.current`
      );
      const element = document.querySelector(`.${selector}.new`);

      if (!originElement || !element) {
        if (element) {
          element.style.display = 'none';
        }
        return;
      }

      const checkbox = originElement.querySelector(
        '.account-recipe-checkbox input'
      );
      if (checkbox && checkbox.checked) {
        const priceElement = originElement.querySelector('.current-price');
        const price = priceElement?.textContent?.trim() || '$0.00';

        const skuDropdown = originElement.querySelector('.current-weight');
        const weight =
          skuDropdown?.options[skuDropdown?.selectedIndex]?.text || '';

        const quantityInput = originElement.querySelector(
          '.account-recipe-quantity'
        );
        const quantity = quantityInput?.value || '0';
        const measureWord =
          quantity === '1' || quantity === 1 ? 'box' : 'boxes';

        const newPrice = element.querySelector('.new-price');
        const newWeight = element.querySelector('.new-weight');
        const newQuantity = element.querySelector('.new-quantity');

        if (newPrice) newPrice.textContent = price;
        if (newWeight) newWeight.textContent = weight;
        if (newQuantity) newQuantity.textContent = `${quantity} ${measureWord}`;
        element.style.display = 'block';
      } else {
        element.style.display = 'none';
      }
    });
  }
  cancelOrDiscard() {
    if (!this.hasTransitionSectionTarget) return;
    if (this.transitionSectionTarget.hidden) return;
    window.location.reload();
  }
  detectTransition() {
    return detectTransition(
      this.originalRecipesValue,
      this.transitionMappingsValue,
      pendingRecipes()
    );
  }

  applyTransitionState(isTransition) {
    const labels = isTransition
      ? this.constructor.TRANSITION_LABELS
      : this.constructor.DEFAULT_LABELS;

    if (this.hasTransitionSectionTarget) {
      this.transitionSectionTarget.hidden = !isTransition;
    }
    if (this.hasDefaultHeaderTarget) {
      this.defaultHeaderTarget.hidden = isTransition;
    }
    if (this.hasConfirmButtonTarget) {
      this.confirmButtonTarget.textContent = labels.confirm;
    }
    if (this.hasCancelButtonTarget) {
      const label =
        this.cancelButtonTarget.querySelector('span') || this.cancelButtonTarget;
      label.textContent = labels.cancel;
    }
  }
}
